var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.382091 2.22447L1.78422 0.822348L8.16716 7.20529L14.5251 0.847372L15.8776 2.19989L9.51968 8.55781L15.9264 14.9645L14.5242 16.3666L8.11756 9.95994L1.73547 16.342L0.382944 14.9895L6.76504 8.60742L0.382091 2.22447Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSymbol);
export default __webpack_public_path__ + "static/media/close-symbol.6d4e99ed7956f395c7e8f900e51b5df9.svg";
export { ForwardRef as ReactComponent };